angular.module('swapick')
.controller('NotificationsCtrl', NotificationsCtrl);

function NotificationsCtrl (NotificationStore, $ionicPopup) {

    this.objects = NotificationStore.getSavedNotifications();

    this.dropNotification = (obj, idx) => {
        NotificationStore.getSavedNotifications();
        this.objects = NotificationStore.clearNotification(idx);
    }

    this.confirmDropNotification = function (obj, index) {
      var confirmPopup = $ionicPopup.confirm({
        title: 'Elimina notifica',
        cancelText: 'Annulla',
        scope: $scope,
        template: '<p>Confermi eliminazione?</p>'
      });

      confirmPopup.then(function (res) {
        if (res) {
          this.dropNotification(obj, index);
        } else {
        }
      });
    };


}



// WEBPACK FOOTER //
// ./src/controllers/notifications-controller.js